import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';

import * as Sentry from "@sentry/react";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { msalConfig } from "./components/auth/authConfig.js";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { MahiContextProvider } from './components/state/MahiContext';
const env = process.env.REACT_APP_ENV; // 'local', 'test' or 'production' (to match files e.g. config.local.json)

//
// Set up Sentry to track errors. See: https://sentry.io/northpower/hiko/getting-started/javascript-react/
//
Sentry.init({
  dsn: "https://76d68b139b8642428bcfc519ca811e1b@o134070.ingest.sentry.io/6556168",
  integrations: [new Sentry.BrowserTracing()],
  //
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  //
  tracesSampleRate: 0, // Probability of tracing this transation: 0 to disable tracing, 1 to trace every page refresh or in-app navigation

  //
  // tell Sentry the environment
  //
  environment: env,
  release: process.env.REACT_APP_SENTRY_RELEASE,

});

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));

function renderApp() {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <MahiContextProvider>
          <BrowserRouter>
            <App/>
          </BrowserRouter>
        </MahiContextProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}

// Initialize MSAL before render so React 18's double effect does not leave startup stuck.
msalInstance.initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .catch((error) => {
    console.error('MSAL failed to initialize', error);
  })
  .finally(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
